import { useCallback } from 'react';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { getIovationBlackbox } from 'js/hooks/auth';
import { useLoginByCredentials, useRegister } from 'js/hooks/auth/hooks';
import { useHandleActions } from 'js/components/system/App/hooks';

export const useOnSubmit = () => {
    const register = useRegister();
    const login = useLoginByCredentials();
    const getErrorMessage = useGetErrorMessage();
    const handleActions = useHandleActions();

    return useCallback(async function process({
        dataMap,
        addressDetails,
        tags,
        validationToken,
        requestReCaptchaToken
    }) {
        try {
            const {
                userId,
                actions
            } = await register({
                addressDetails,
                // @TODO contactAddress,
                dataMap,
                // @TODO depositLimits,
                // @TODO betLimits,
                // @TODO lossLimits,
                // @TODO betLimitsAction,
                // @TODO lossLimitsAction,
                // @TODO contactPreferences,
                tags,
                token: validationToken,
                blackbox: getIovationBlackbox()
            });

            const { password } = dataMap;

            await login(userId, password, false, true);
            await handleActions(actions);
        } catch (error) {
            const { data: { errorCode } = {} } = error?.response || error || {};
            const errorMsg = getErrorMessage(error);

            if (errorCode === 301) {
                try {
                    const { token } = await requestReCaptchaToken();

                    return await process({
                        dataMap,
                        addressDetails,
                        tags,
                        requestReCaptchaToken,
                        validationToken: token
                    });
                } catch (validationError) {
                    return errorMsg;
                }
            }

            return errorMsg;
        }
    }, [
        login,
        register,
        handleActions,
        getErrorMessage
    ]);
};
